import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.automation.actions', {
    deleteCompanySuccess: 'The Organisation has been removed.',
});
